import { NewEventModal } from "./NewEventModal";

export default NewEventModal;
